import { Routes } from '@angular/router';

import { APP_PATHS } from '../../core/routing/app-paths';

/**
 * Public auth screens, mounted at the TOP LEVEL of `app.routes.ts` — outside both
 * layouts (P4, „Poprawki do panelu klienta"): every screen here renders the
 * full-screen `AuthShellComponent`, so the public header and footer have nothing to
 * add. The routes landed with the session core (S-01 phase 4) because the panel
 * guard redirects here.
 */
export const AUTH_ROUTES: Routes = [
  {
    path: APP_PATHS.login,
    title: 'Logowanie — EMPIRIA',
    loadComponent: () => import('./login/login-page.component').then((m) => m.LoginPageComponent),
  },
  {
    path: APP_PATHS.register,
    title: 'Rejestracja — EMPIRIA',
    loadComponent: () =>
      import('./register/register-page.component').then((m) => m.RegisterPageComponent),
  },
  {
    path: APP_PATHS.activate,
    title: 'Aktywacja konta — EMPIRIA',
    loadComponent: () =>
      import('./activate/activate-page.component').then((m) => m.ActivatePageComponent),
  },
  {
    path: APP_PATHS.forgotPassword,
    title: 'Nie pamiętam hasła — EMPIRIA',
    loadComponent: () =>
      import('./forgot-password/forgot-password-page.component').then(
        (m) => m.ForgotPasswordPageComponent,
      ),
  },
  {
    path: APP_PATHS.resetPassword,
    title: 'Ustawienie nowego hasła — EMPIRIA',
    loadComponent: () =>
      import('./reset-password/reset-password-page.component').then(
        (m) => m.ResetPasswordPageComponent,
      ),
  },
  {
    // Landing page of the link mailed to the NEW address (S-14 phase 4). NO `canActivate`
    // ON PURPOSE, and it is not an oversight to be tidied up later: the customer opens
    // this link from the mailbox they are proving they can read, usually in a browser
    // that holds no session at all. A guard would bounce every such link to the login
    // screen and make the whole flow undeliverable. `verify:s14-p4` (krok 3) executes
    // this table and fails if a guard ever appears here.
    path: APP_PATHS.confirmEmailChange,
    title: 'Potwierdzenie zmiany adresu logowania — EMPIRIA',
    loadComponent: () =>
      import('./confirm-email-change/confirm-email-change-page.component').then(
        (m) => m.ConfirmEmailChangePageComponent,
      ),
  },
];
